var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraseat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3394 47.6074C53.5846 46.3189 52.3803 45.3548 50.9578 44.9004L50.7848 44.8485C50.5768 44.7821 50.3622 44.7386 50.1448 44.7188C49.0342 44.9935 47.9892 45.4858 47.0703 46.1672C46.1513 46.8486 45.3767 47.7056 44.7913 48.6885L43.961 60.5371C43.8313 60.5371 43.8918 60.5371 43.961 60.5371L43.8918 62.2669H44.5491C53.0853 62.2669 54.6853 55.0366 54.8237 54.3015C55.5329 51.6117 55.3513 49.3544 54.3394 47.6074Z",
    fill: "url(#paint0_linear_383_10607)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0393 60.5433L19.1744 48.7206C18.4393 48.046 16.8047 44.9152 13.8209 44.7422C13.6044 44.7679 13.3903 44.8113 13.1809 44.8719H13.0598C11.6056 45.3136 10.3706 46.2861 9.60033 47.5962C8.57114 49.326 8.40682 51.6006 9.11601 54.2903C9.25439 55.0168 10.8457 62.2557 19.3906 62.2557H20.0479L19.9787 60.526C20.1084 60.5433 20.1603 60.5433 20.0393 60.5433Z",
    fill: "url(#paint1_linear_383_10607)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3751 14.5612H27.1048V17.3807H24.1643V30.198H39.8443V17.3807H36.9037V14.5612H38.6335C39.072 14.5614 39.5057 14.4691 39.9062 14.2905C40.3067 14.1119 40.6651 13.8509 40.958 13.5245C41.2509 13.1981 41.4718 12.8137 41.6063 12.3963C41.7407 11.9788 41.7857 11.5378 41.7383 11.1018L40.9946 4.53746C40.919 3.76374 40.5567 3.04628 39.979 2.52614C39.4012 2.006 38.6498 1.72081 37.8724 1.72665H26.1275C25.353 1.72277 24.6048 2.00772 24.0291 2.52587C23.4534 3.04401 23.0915 3.75815 23.014 4.52881L22.2702 11.1104C22.2228 11.5464 22.2678 11.9875 22.4023 12.4049C22.5367 12.8223 22.7576 13.2068 23.0505 13.5331C23.3435 13.8595 23.7019 14.1205 24.1024 14.2991C24.5029 14.4778 24.9365 14.57 25.3751 14.5699V14.5612ZM35.174 17.3807H28.8259V14.5612H35.174V17.3807Z",
    fill: "url(#paint2_linear_383_10607)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7727 43.0364L50.0322 42.9758H50.2916H50.4733C49.7814 38.738 48.8819 31.8537 49.2884 26.3964C49.4798 25.3 49.4475 24.1763 49.1934 23.0928C48.9392 22.0093 48.4685 20.9884 47.8095 20.0915C46.4689 18.4396 44.35 17.4969 41.5738 17.3672V47.4558H22.4257V17.4191C19.6322 17.5748 17.5306 18.4915 16.19 20.1434C15.5295 21.0396 15.0572 22.0602 14.8016 23.1437C14.5459 24.2273 14.5122 25.3514 14.7024 26.4483C15.1089 31.9056 14.2095 38.7899 13.5176 43.0277C13.5578 43.0318 13.5984 43.0318 13.6387 43.0277H13.7943H13.95C17.0722 43.2094 18.9576 45.6223 20.0041 46.9542C20.1302 47.1343 20.2659 47.3075 20.4106 47.4731L20.8689 47.9229L20.9641 48.6148V49.2202L21.8808 62.1931H21.8289V62.271H42.1533L42.2916 58.8115H42.3781L43.1306 48.1564L43.3554 47.7931C44.0533 46.612 44.9807 45.5826 46.0829 44.7656C47.185 43.9486 48.4397 43.3607 49.7727 43.0364Z",
    fill: "url(#paint3_linear_383_10607)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1553 31.9297H39.8439V45.7243H24.1553V31.9297Z",
    fill: "url(#paint4_linear_383_10607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_10607",
    x1: 43.8848,
    y1: 53.4928,
    x2: 55.2511,
    y2: 53.4928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_10607",
    x1: 8.68359,
    y1: 53.4989,
    x2: 20.1076,
    y2: 53.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_383_10607",
    x1: 22.252,
    y1: 15.9623,
    x2: 41.7566,
    y2: 15.9623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_383_10607",
    x1: 13.5176,
    y1: 39.8191,
    x2: 50.4733,
    y2: 39.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_383_10607",
    x1: 24.1553,
    y1: 38.827,
    x2: 39.8439,
    y2: 38.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraseat);
export default __webpack_public_path__ + "static/media/extraseat.80cda2bf3280914bfc43a714ee070970.svg";
export { ForwardRef as ReactComponent };